import ArrowRight2SVG from "../../../../../svgs/ArrowRight2SVG";
import MoriButton from "../../../../systemDesign/Buttons/MoriButton";
import FrequentCard from "./Cards/FrequentCard";

const Frequent = () => {
  return (
    <div className="py-[20px] mt-4 lg:mt-6 border-b border-stroke1">
      <div className="px-10">
        <h2 className="my-10 text-text3 text-[22px] md:text-[32px] text-center mini:text-left">
          Frequent topics
        </h2>
        <div className="flex flex-col items-center gap-4 lg:flex-row lg:h-[180px] lg:justify-between mini:items-end mini:[&>div:nth-child(odd)]:self-start">
          <FrequentCard
            title1="Swapped out the for"
            title2="some variants we needed."
            topic="Civil low"
          />
          <FrequentCard
            title1="Swapped out"
            title2="the for some variants we needed."
            topic="civil prousedure law"
          />
          <FrequentCard
            title1="Swapped out the for"
            title2="some variants we needed."
            topic="criminal law"
          />
          <FrequentCard
            title1="Swapped out"
            title2="the for some variants we needed."
            topic="civil proceeding low"
          />
        </div>
        <div className="flex flex-col gap-10 items-center justify-between my-8 lg:flex-row">
          <h3 className="text-text2 text-[14px] sm:text-[18px] lg:text-[24px] max-w-[700px]">
            <span className="text-text3">
              Deploy an AI app in seconds on Vercel,
            </span>{" "}
            using our pre-built templates. Easily stream long-running LLM
            responses for a better user experience with{" "}
            <span className="text-text3"> zero-config infrastructure </span>{" "}
            that's always globally performant.
          </h3>
          <div className="lg:w-[260px] self-start lg:self-center">
            <MoriButton
              text="View more"
              textCustomClass="!text-text3 !text-[14px]"
              customClass="!w-[200px] lg:!w-[260px] !flex-row-reverse !gap-[5px] !items-center !justify-between !bg-transparent !h-[40px] cursor-pointer rounded-full border border-stroke3"
              icon={<ArrowRight2SVG width={22} />}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Frequent;
